export default "__VITE_ASSET__DHglgkji__"